<template>
  <div class="container">
    <div class="search" v-if="exfalg">
      <el-input
        :placeholder="$t('search.placeholderName')"
        v-model="keywords"
      ></el-input>
      <div class="button" @click="search()">{{ $t("common.search") }}</div>
    </div>

    <!----------------------------------------------------------->
    <div class="mainContent">
      <div class="rightContent" v-if="lists.length > 1">
        <div v-for="(item, k) in lists" :key="k" class="content">
          <div class="vedio1" @click="entryDetail(item.id)">
            <div class="titleLogo">
              <img
                :src="baseUrl + item.comCover"
                v-if="item.comCover.includes('/hz/hzupload')"
              />
              <img src="../../../static/占位-展商-列表.png" alt="" v-else />
            </div>

            <div class="main">
              <div class="company">{{ item.companyNameC }}</div>

              <div class="number">
                <span>{{ $t("common.boothNum") }}</span
                >{{ item.hzBoothList[0].boothNum }}
              </div>
            </div>
          </div>

          <div class="bottom">
            <!-- 咨询展商 -->
            <div class="bottomLeft" @click="consult(item)">
              {{ $t("mobile.talk") }}
            </div>
            <!--收藏展商  -->
            <div
              class="bottomRight"
              v-if="item.collectStatus == 0"
              @click="toggle(item)"
            >
              {{ $t("mobile.Favorites") }}
            </div>
            <!--收藏展商  -->
            <div
              class="bottomRight"
              v-if="item.collectStatus == 1"
              @click="toggle(item)"
            >
              {{ $t("mobile.cancel") }}
            </div>
          </div>
        </div>
      </div>
      <div class="boxImg" v-else>
        <img src="../../../static/empty.png" alt="" />
        <div>{{ $t("search.nodata") }}</div>
      </div>
    </div>
    <!----------------------------------------------------------->
  </div>
</template>
<script>
import products from "../../../../Json/searchLists.js";
import productsEn from "../../../../Json/searchListsEn.js";
import { getExLists, collect } from "../../../../api/recommend.js";
import { forMat, backExhibitorDetail } from "../../../../utils/common.js";
export default {
  data() {
    return {
      baseUrl: forMat(),
      productTypeList: null,
      type: "",
      keywords: "",
      lists: [],
      exhibitorDetailUrl: backExhibitorDetail(),
    };
  },
  //  props: ["flag",'exFlag'],
  props: {
    exfalg: {
      type: [Boolean],
      default: true,
    },
    flag: {},
  },

  created() {
    const lang = localStorage.getItem("lang");
    if (lang == "en") {
      this.productTypeList = productsEn;
    } else {
      this.productTypeList = products;
    }
    const params = {
      value: {
        exhibitsType: [],
        keyword: "",
      },
    };
    this.getLists(params);
  },
  methods: {
    consult(item) {
      // 用户id
      this.$router.push({
        name: "messageDetail",
        query: {
          receiveUserId: item.id,
        },
      });
    },
    goDetail(id) {
      window.location.href = this.exhibitorDetailUrl + "?id=" + id;
    },
    async toggle(item) {
      let status;
      if (item.collectStatus === 0) {
        // 要添加收藏
        status = true;
      } else if (item.collectStatus === 1) {
        status = false;
      }
      const params = {
        objId: item.id,
        flag: status,
        type: 1,
      };
      try {
        const { data } = await collect(params);
        if (data.code === 200) {
          if (item.collectStatus === 0) {
            item.collectStatus = 1;
            this.$message({
              showClose: true,
              message: "收藏成功！",
              type: "success",
            });
          } else {
            item.collectStatus = 0;
            this.$message({
              showClose: true,
              message: "取消收藏成功！",
              type: "success",
            });
          }
        }
      } catch (err) {
        if (item.collectStatus === 0) {
          this.$message({
            showClose: true,
            message: "收藏失败！",
            type: "error",
          });
        } else {
          this.$message({
            showClose: true,
            message: "取消收藏失败！",
            type: "error",
          });
        }
        console.log(err.msg);
      }

        //储存local的值，用于更新收藏数据的状态
      localStorage.setItem('collentChange',Math.random()*10);
    },
    async getLists(params) {
      try {
        const { data } = await getExLists(params);
        if (data.code === 200) {
           this.lists = data.data.list;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    search() {
      // 搜索函数 type keywords
      const params = {
        value: {
          exhibitsType: [],
          keyword: "",
        },
      };
      if (this.type.length === 1) {
        // 一级筛选
        params.value.exhibitsType = this.type;
      }
      if (this.type.length === 2) {
        // 二级筛选
        const arr = this.productTypeList.filter(
          (it) => it.value === this.type[0]
        );
        const arr1 = arr[0].children.filter((it) => it.value === this.type[1]);
        const arr2 = arr1[0].children;
        arr2.map((item) => {
          params.value.exhibitsType.push(item.value);
        });
      }
      if (this.type.length === 3) {
        // 三级筛选
        params.value.exhibitsType.push(this.type[2]);
      }
      params.value.keyword = this.keywords;
      this.getLists(params);
    },
    handleCascader() {},

    //查看更多
    lookMore() {
      this.$router.push({ name: "recommendInfo", query: { tab: "" } });
    },


  //跳转进入
   entryDetail(id){
       window.location.href = this.exhibitorDetailUrl + '?id=' + id;
   }



  },
  watch: {
    flag(newName, oldName) {
      const params = {
        value: {
          exhibitsType: [],
          keyword: "",
        },
      };
      this.getLists(params);
      this.type = "";
      this.keywords = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 35vh;
  padding: 0px 15px;
  box-sizing: border-box;
  background-color: white;
  .search {
    display: flex;
    padding-top: 15px;
    .button {
      width: 90px;
      height: 36px;
      background: #006fb8;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
      margin-left: 20px;
      cursor: pointer;
    }
  }
  .mainContent {
    padding-top: 20px;
    .rightContent {
      display: grid;
      grid-template-columns: repeat(2, 48%);
      justify-content: space-between;
      box-sizing: border-box;
      grid-column-gap: 10px;
      grid-row-gap: 10px;
     padding-bottom: 35px;
               background-color: #ffffff;
      .content {
        background-color: #ffffff;
        border: 1px solid #e0e0e0;
        position: relative;
        cursor: pointer;
        .vedio1 {
          .main {
            width: 100%;
            height: 110px;
            background-color: rgba(76, 179, 254, 0.11);
            margin-top: 47px;
            box-sizing: border-box;
            text-align: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333;
            .company {
              color: #333333 !important;
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              line-height: 20px;
              padding: 0px 9px;
              box-sizing: border-box;
              height: 72px;
              padding-top: 33px;
            }
            .number {
              font-size: 15px;
              font-family: Arial-BoldMT, Arial;
              font-weight: normal;
              color: #333333;
              line-height: 17px;
              font-weight: 600;
              padding-top: 9px;

              span {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }
            }
          }
          .titleLogo {
            width: 138px;
            height: 60px;
            background: #ffffff;
            box-shadow: 0px 0px 51px 0px #e8ecf0;
            position: absolute;
            top: 10px;
            left: 0px;
            right: 0px;
            margin: auto;
            text-align: center;
            justify-content: center;
            align-items: center;
            display: flex;
            img {
              max-width: 99px;
              max-height: 38px;
            }
          }
        }

        .bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 7px 0px;
          box-sizing: border-box;
          color: #006fb8;
          position: relative;
          .bottomLeft {
            font-size: 11px;
            cursor: pointer;
            flex: 1;
        
            text-align: center;
          }
          .bottomLeft::after {
            content: "";
            position: absolute;
            width: 1px;
            height: 0.6875rem;
            background: #e0e0e0;
            top: 9.6px;
            left: 78px;

            background: #e0e0e0;
          }
          .bottomLeft:hover {
            color: #006fb8;
          }
          .bottomRight {
            flex: 1;
            display: flex;
            font-size: 11px;
            justify-content: center;
            align-items: center;
            text-align: center;
            .nu1 {
              img {
                cursor: pointer;
                width: 24px;
                height: 24px;
              }
              .hoversty {
                width: 80px;
                height: 30px;
                color: #fff;
                background: rgba(0, 0, 0, 0.7);
                display: none;
                text-align: center;
                padding-top: 2px;
                position: absolute;
                right: -18px;
                bottom: 20px;
                border-radius: 10px;
                line-height: 30px;
              }
            }
            .nu1:hover .hoversty {
              display: block;
            }
            .nu2 {
              img {
                cursor: pointer;
                width: 24px;
                height: 24px;
              }
              .hoversty {
                width: 40px;
                height: 28px;
                color: #fff;
                background: rgba(0, 0, 0, 0.7);
                display: none;
                text-align: center;
                padding-top: 2px;
                position: absolute;
                right: -21px;
                bottom: 20px;
                border-radius: 10px;
                line-height: 28px;
                z-index: 99;
              }
            }
            .nu2:hover .hoversty {
              display: block;
            }
          }
        }
      }
      .empty {
        position: relative;
        img {
          width: 150px;
          height: 150px;
        }
        span {
          position: absolute;
          bottom: 0;
          left: 0px;
          right: 0px;
          top: 0px;
          margin: auto;
        }
      }
    }
  }
}
</style>
<style scoped>
.el-cascader {
  line-height: 32px;
}
.el-input {
  width: 240px;
  height: 36px;
}
.search >>> .el-input__inner {
  height: 36px;
}
</style>
<style lang="scss">
.boxImg {
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  img {
    width: 220px;
    height: 180px;
    margin: 0 auto;
  }
}
</style>
